// extracted by mini-css-extract-plugin
export default {"button":"FavoriteButton_button__O8uhU","heartIcon":"FavoriteButton_heartIcon__Rn4E2","heartIconFilled":"FavoriteButton_heartIconFilled__1uBnM"};